import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface IncorrectStoreHoursProps extends BaseTemplateProps {
  retailerName: string
  whlNamesList: string
}

export const IncorrectStoreHours: TemplateDefinition<IncorrectStoreHoursProps> = {
  renderParams: (props: IncorrectStoreHoursProps) => ({
    messageKey: 'notificationsDomain.templates.incorrectStoreHours',
    values: {
      retailerName: props.retailerName,
      whlNamesList: props.whlNamesList,
    },
  }),
}
